import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { Media } from '@app/shared';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';


@Injectable()
export class MediaService implements RequestService {

  redirectUrl: String = "";
  isBusy = false;
  private serviceUrl = 'media';  // URL to web api

  constructor(
    private http: HttpClient,
    ) { }


  /** GET media by id. Will 404 if id not found */
  /** GET media by id. Will 404 if id not found */
  getMedias(val:string,includeAssets?:boolean): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    let url = `${environment.baseURL}${this.serviceUrl}/${val}`;

    if(includeAssets)
      url +=`?include=mediaassets.media`
    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    return this.http.get<Media[]>(encodeURI(url),{
       //params : httpParams
       headers: headers
    })
  }

  /** GET Decorations */
  getDecorations(val:string,includeAssets?:boolean): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    let project = window.location.href;
    const regex = /project=.*?[^&]+/g;
    let uuid = String(project.match(regex));
    uuid = uuid.substring('project='.length);
    // let url = `${environment.baseURL}decoration/${val}`;
    let url = `${environment.baseURL}decoration/${val}?campaignUUID=${uuid}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    return this.http.get<Media[]>(encodeURI(url),{
       //params : httpParams
       headers: headers
    })
  }


  getMedia(media:Media): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${media.id}/media`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Media>(url,{
       //params : httpParams
       headers: headers
    })

  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better media of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/media.service.ts